import { privateAxios } from '@/services/api'

export const _getLocation = (query) => {
    return privateAxios.get(`/here/geocode?q=${encodeURIComponent(query)}`)
        .then(response => response.data)
}
